import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AnalyticsService } from '@sm360/widget-commons-general';
import { Vehicle, VehicleConstants } from '@sm360/widget-commons-vehicle';
import { ConfigsService, LocaleService } from '@sm360/widget-commons-core-services';

import axios from 'axios';

function HocWithAnalytics(WrappedComponent) {
    class withAnalytics extends Component {
        constructor(props) {
            super(props);

            this.state = {
                trackingExecuted: false,
            };
            this.executeTracking = this.executeTracking.bind(this);
        }

        componentDidMount() {
            this.executeTracking(this.props.vehicle);
        }

        componentWillReceiveProps(nextProps) {
            this.executeTracking(nextProps.vehicle);
        }

        getVehicleConditionLabel(vehicleConditionType) {
            switch (vehicleConditionType) {
                case VehicleConstants.CONDITIONS.NEW:
                    return 'new';
                case VehicleConstants.CONDITIONS.USED:
                    return 'used';
                case VehicleConstants.CONDITIONS.DEMO:
                    return 'demo';
                case VehicleConstants.CONDITIONS.CERTIFIED:
                    return 'certified';
                default:
                    return 'n/a';
            }
        }

        pushToDataLayer(vehicle) {
            // Destructuring the vehicle object to exclude some properties useless for the analytics
            const {
                flags,
                features,
                multimedia,
                purchaseMethods,
                warranty,
                configuration,
                configurationId,
                configurationToken,
                organizationUnitName,
                vehicleConditionType,
                ...cleanedVehicle
            } = vehicle.toJS();

            const vehicleAnalytics = {
                ...cleanedVehicle,
                model: vehicle.model,
                carId: `${vehicle.vehicleId}`,
                isDemo: vehicle.vehicleConditionType === VehicleConstants.CONDITIONS.DEMO,
                stockNo: vehicle.stockNumber,
                vehicleCategory: 'car',
                isSold: vehicle.sold,
                id: `${vehicle.vehicleId}`,
                hasVideo: !!vehicle.multimedia.video.url,
                name: `${vehicle.year} ${vehicle.make} ${vehicle.model} (${vehicle.stockNumber})`,
                year: `${vehicle.year}`,
                rebate: `${vehicle.discount}`,
                trim: vehicle.trim,
                extColor: vehicle.exteriorColour,
                mileage: `${vehicle.odometer}`,
                condition: this.getVehicleConditionLabel(vehicle.vehicleConditionType),
                isNew: vehicle.vehicleConditionType === VehicleConstants.CONDITIONS.NEW,
                isCertified: vehicle.vehicleConditionType === VehicleConstants.CONDITIONS.CERTIFIED,
                picturesCount: vehicle.multimedia.pictures.length,
                hasPictures: vehicle.multimedia.pictures.length > 0,
                makeModel: `${vehicle.make}/${vehicle.model}`,
                transmission: vehicle.transmission,
                hasGallery: vehicle.multimedia.pictures.length > 0,
                category: 'car',
                isOnSpecial: vehicle.discount > 0,
                color: vehicle.exteriorColour,
                salePrice: `${vehicle.sellingPrice}`,
                make: vehicle.make,
                regularPrice: `${vehicle.sellingPrice}`,
                tagline: vehicle.tagLine,
            };

            AnalyticsService.pushToDataLayer('inventory-detail', { ...vehicleAnalytics });
        }

        buildAdacadoPixelTag(vehicle) {
            const { make, model, year, vin } = vehicle;

            const adacadoUrl =
                `https://pixel.adacado.com/1000846?segment=vehicle&dealerid=${ConfigsService.getOrganizationUnitId()}` +
                `&make=${encodeURIComponent(make)}&model=${encodeURIComponent(model)}` +
                `&year=${encodeURIComponent(year)}&vin=${encodeURIComponent(vin)}` +
                `&language=${LocaleService.getSimpleLocale()}`;

            axios.get(adacadoUrl);
        }

        executeTracking(vehicle) {
            if (!vehicle || !vehicle.vehicleId || this.state.trackingExecuted) {
                return;
            }
            this.pushToDataLayer(vehicle);
            this.buildAdacadoPixelTag(vehicle);
            this.setState({ trackingExecuted: true });
        }

        render() {
            return (
                <div>
                    <WrappedComponent {...this.props} />
                </div>
            );
        }
    }

    withAnalytics.defaultProps = {
        vehicle: null,
    };

    withAnalytics.propTypes = {
        vehicle: PropTypes.instanceOf(Vehicle.VehicleModel),
    };

    withAnalytics.displayName = 'withAnalytics';

    return withAnalytics;
}

HocWithAnalytics.displayName = 'HocWithAnalytics';

export default HocWithAnalytics;
